document.addEventListener('DOMContentLoaded', function () {
    const promoBars = document.querySelectorAll('.promo-banner-bar');

    promoBars.forEach(banner => {
        const slides = Array.from(banner.getElementsByClassName('promo-bar-text'));
        if (slides.length === 0) return; // Early return if no slides

        let current = 0;

        // Get dynamic fade durations from data attributes
        const fadeInDuration = Number(banner.getAttribute('data-fade-in')) || 500;
        const fadeOutDuration = Number(banner.getAttribute('data-fade-out')) || 500;

        // Function to set the visibility of a slide
        const setSlideVisibility = (index, isVisible) => {
            slides[index].classList.toggle('opacity-0', !isVisible);
            slides[index].classList.toggle('active', isVisible);
        };

        // Function to check and update the number of lines
        const checkPromoBarTextLines = () => {
            const promoBarContainer = banner.querySelector('.promo-banner-wrapper');
            const visibleBar = document.querySelector('.visible-bar'); 
            let hasThreeLines = false;
            let hasFourLines = false;

            slides.forEach(promoBarText => {
                const lineHeight = parseFloat(getComputedStyle(promoBarText).lineHeight);
                const height = promoBarText.offsetHeight;
                const numberOfLines = Math.ceil(height / lineHeight);

                hasThreeLines ||= numberOfLines === 3;  
                hasFourLines ||= numberOfLines >= 4;    
            });

            // Add or remove the classes based on the number of lines
            promoBarContainer.classList.toggle('xs:h-spacing-9xl', hasFourLines); 
            promoBarContainer.classList.toggle('xs:h-spacing-6xl', hasThreeLines);

            // Adjust the top position based on line count
            if (hasFourLines && visibleBar) {
                visibleBar.style.top = "-75px";  
            } else if (hasThreeLines && visibleBar) {
                visibleBar.style.top = "-50px";  
            }
        };

        // Check if there's only one slide
        if (slides.length === 1) {
            setSlideVisibility(current, true);
            checkPromoBarTextLines(); // Ensure height is adjusted
            return; 
        }

        setSlideVisibility(current, true);

        // Start the interval to change slides
        const intervalId = setInterval(() => {
            setSlideVisibility(current, false);
            setTimeout(() => {
                current = (current + 1) % slides.length;
                setSlideVisibility(current, true);
            }, fadeOutDuration);
        }, fadeInDuration + fadeOutDuration);

        // Initial check on page load
        checkPromoBarTextLines();

        // Use ResizeObserver for more reliable updates
        const resizeObserver = new ResizeObserver(() => {
            checkPromoBarTextLines();
        });

        // Observe each slide for changes
        slides.forEach(slide => resizeObserver.observe(slide));
    });
});
